import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "14px",
        fontFamily: "Open Sans",
    },
}));
